import { CartData } from '@monorepo/types';
import { useCart, useCurrencies, useProducts } from '@hub/api/queries';
import { getProject } from '../../../helpers/get-project';

export const useCartData = (): CartData => {
  const {
    data: cart,
    isLoading: isCartLoading,
    isError: isCartError,
  } = useCart();
  const {
    data: products,
    isLoading: isProductsLoading,
    isError: isProductsError,
  } = useProducts();
  const {
    data: currencies,
    isLoading: isCurrenciesLoading,
    isError: isCurrenciesError,
  } = useCurrencies();
  const { project } = getProject();

  const isLoading = isCartLoading || isProductsLoading || isCurrenciesLoading;
  const hasError = isCartError || isProductsError || isCurrenciesError;

  return isLoading || hasError
    ? {}
    : {
        cart,
        products,
        currencies,
        project,
      };
};
